import useTranslation from 'next-translate/useTranslation';
import { WeeeIcon } from '@/components/common/Icon';
import dayjs from '@/utils/dayjs';
import classNames from 'classnames';
import { hideUserName } from '@/utils/tool';
import React, { useState } from 'react';
import styles from './index.module.scss';

const defaultShowNum = 5;

const COLORSLIST = [
  '#19ACE3',
  '#40CEB7',
  '#FFDA2D',
  '#FFA832',
  '#999999',
  '#AE2F9B',
  '#343579',
  '#000000',
  '#86C436',
  '#2B6C03'
];

function BuyerInfo(props) {
  const { t, lang } = useTranslation('common');
  const {
    info = {},
    showAvatarBorder = true,
    showBodyBorder = true,
    showPoints = true,
    showCreateTime = true,
    showAnonymousUser = false,
    index,
    hideAward = false
  } = props;
  let isAward = info?.userId == '5044';

  return (
    <>
      {isAward && hideAward ? (
        <></>
      ) : (
        <div className={classNames(styles.buyerInfo)}>
          <div className={classNames(styles.avatar, { [styles.avatarBorder]: showAvatarBorder })}>
            {showAnonymousUser ? (
              <div className={styles.anonymousImg} style={{ background: COLORSLIST[index % 10] }}>
                <WeeeIcon className={styles.icon} type="iconselected3" />
              </div>
            ) : (
              <img src={info?.headImgUrl} alt={info?.headImgUrl} />
            )}
          </div>
          <div className={classNames(styles.body, { [styles.bodyBorder]: showBodyBorder })}>
            <div className={styles.info}>
              <div className={styles.name}>
                {isAward
                  ? t('share_progress_invite_first_name')
                  : showAnonymousUser
                  ? hideUserName(info?.alias)
                  : info?.alias}
              </div>
              {showCreateTime && (
                <div className={styles.time}>{dayjs.unix(+info?.createTimestamp).format('MM/DD/YYYY hh:mm A')}</div>
              )}
            </div>
            <div className={styles.tags}>
              {!isAward && info?.type === '1' && (
                <div className={styles.bought}>{t('share_progress_invite_buy_label')}</div>
              )}

              {info?.points > 0 && showPoints && (
                <div className={classNames(styles.points, { [styles.isAward]: isAward })}>
                  {isAward && <div>{t('share_progress_invite_first_label')}</div>}+{info?.points}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function BuyerList(props) {
  const { t, lang } = useTranslation('common');
  const {
    data = [],
    showAvatarBorder = true,
    showBodyBorder = true,
    showPoints = true,
    showAnonymousUser = false,
    showCreateTime = true,
    hideUserName = false,
    showMoreBtn = true,
    hideAward = false
  } = props;
  const [showNum, setShowNum] = useState<number>(showMoreBtn ? defaultShowNum : data?.length);
  const [showMore, setShowMore] = useState<boolean>(() => {
    return data?.length > defaultShowNum && showMoreBtn;
  });
  return (
    <div>
      {data?.slice(0, showNum).map((item, index) => (
        <BuyerInfo
          key={index}
          info={item}
          index={index}
          showAvatarBorder={showAvatarBorder}
          showBodyBorder={showBodyBorder}
          showPoints={showPoints}
          showAnonymousUser={showAnonymousUser}
          showCreateTime={showCreateTime}
          hideUserName={hideUserName}
          hideAward={hideAward}
        />
      ))}
      {showMore && (
        <div
          className={styles.showMore}
          onClick={() => {
            setShowMore(false);
            setShowNum(data?.length);
          }}>
          <span>{t('show_more')}</span>
          <WeeeIcon type="iconarrow-down" className={styles.arrowIcon} />
        </div>
      )}
      <div className="pb-safe" />
    </div>
  );
}
